import React, { useState, useEffect } from 'react';
import { Button } from 'antd';
import './index.less';

let timer = null;
const CountDownBtn = (props) => {
  const waitTime = props.waitTime || 60;
  const btnText = props.btnText || '获取验证码';
  const downBtnText = props.downBtnText || '重新获取';
  const [disabled, setDisabled] = useState(props.disabled || false);
  let [count, setCount] = useState(waitTime);

  useEffect(()=>{
    return () => {
      clearTimer();
    }
  }, []);

  useEffect(() => {
    if (timer === null) {
      setDisabled(props.disabled);
    }
  }, [props.disabled])

  const handleClick = async () => {
    try {
      props.onCountStart && await props.onCountStart();
      setDisabled(true);
      excuCutdownTime();
    } catch(e) {
      clearTimer();
    }
  };

  const clearTimer = () => {
    clearInterval(timer);
    timer = null;
    setDisabled(false);
  };

  const excuCutdownTime = () => {
    setCount(waitTime);
    timer = setInterval(() => {
      // 使用回调方式更新，否则这里获取的是闭包中的局部变量,也就是上方useState返回的count;
      setCount((val) => {
        if (val > 1) {
          return val - 1;
        } else {
          clearTimer();
          if (props.onCountEnd) props.onCountEnd();
          return val;
        }
      });
    }, 1000);
  };

  return (
    <span className="count-down-btn">
      <Button
        type={timer === null ? 'primary' : 'default'}
        onClick={handleClick}
        disabled={disabled === true}
      >
        {timer === null ? btnText : `${count}s${downBtnText}`}
      </Button>
    </span>
  );
};

export default CountDownBtn;
